import { Deferred, Head, router } from '@inertiajs/react'
import Retool from 'react-retool'
import { useEffect } from 'react'

export default function Billing({ retool_embed_url }: { retool_embed_url: string }) {
  // Retool embeds don't work with the default router, so we need to handle the popstate event manually
  useEffect(() => {
    function onPopstate(e: PopStateEvent) {
      e.stopImmediatePropagation();

      console.log("popstate", window.location.href)
      //  Force retool_embed_url to be updated
      router.visit(window.location.href, {
        only: ['retool_embed_url'],
        preserveState: false,
        preserveScroll: false,
        replace: true,
      });

    }
    window.addEventListener("popstate", onPopstate);

    return () => {
      // Very much a hack -- react cleans up before the event listener is removed
      setTimeout(() => {
        window.removeEventListener('popstate', onPopstate);
      }, 0);
    }
  }, []);

  return (
    <>
      <Head title="Billing Manager" />
      <div className="h-[calc(100vh-3rem)] w-full">
        <Retool url={retool_embed_url} />
      </div>
    </>
  )
}
